// An asset's zone as the site board and asset page show it (CR_20260914 §4.4): "Bay A" with when · who, dimmed
// "last: Bay A" while the asset is away from its custody site, "—" on another site's board. Text only (no HTML).
import { type ZoneFields, zoneDisplay } from '@fleetspoke/core/zones';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSession } from '../auth/session';
import { dateTime, relativeTime } from '../lib/time';

export function ZoneText({ a, siteId }: { a: ZoneFields; siteId?: string }) {
  const { t, i18n } = useTranslation();
  const { me } = useSession();
  const d = zoneDisplay(a, siteId);
  if (d.kind === 'none') return <>—</>;
  const lang = i18n.language;
  const tz = me?.company?.timezone ?? 'Asia/Kuala_Lumpur';
  const title = d.setAt
    ? t('board.zone_set_by', { when: dateTime(d.setAt, lang, tz), who: d.setBy ?? '—' })
    : '';
  const meta = [relativeTime(d.setAt, lang), d.setBy].filter(Boolean).join(' · ');
  return (
    <Tooltip title={title}>
      <Box component="span" data-testid="zone-text">
        {d.kind === 'here' ? (
          <>
            <Typography component="span" variant="body2" sx={{ fontWeight: 500 }}>
              {d.name}
            </Typography>
            {meta ? (
              <Typography variant="caption" display="block" color="text.secondary">
                {meta}
              </Typography>
            ) : null}
          </>
        ) : (
          <Typography component="span" variant="body2" color="text.secondary">
            {t('board.zone_last', { zone: d.name })}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}
